import {NameId} from '@drl/core/models';
import {
  FoodRestriction,
  MedicineRoute,
  Reminder,
} from '@drl/shared/utility/patients-caregiver-utility.enum';

import {MedicineDuration} from './medicine-duration.model';

export class PrescriptionMedicines extends NameId {
  prescriptionId?: number;
  medicineExtId: string;
  startDate: Date;
  duration: number;
  locationOfAdministration?: string;
  dosage?: number;
  frequency?: number;
  timeToTake?: string;
  time: Date;
  route: MedicineRoute;
  instructions: string;
  dosageUnit?: string;
  foodRestriction: FoodRestriction;
  reminderStatus?: Reminder; // display logic
  timeDisplay?: MedicineDuration[]; // display logic
  location: string; // display logic
  foodRestrictionLabel?: string; // display logic
  restrictionImg?: string; //dispplay logic
  medicineAdherence?: string; //display logic
}
